import { Button } from "@/components/Core/Button";
import { Input } from "@/components/Core/Input";
import { camelCaseToLower, RenderToast } from "@/helper/HelperFunction";
import { useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./AddEditBrandModal.module.css";

const AddEditBrandModal = ({
  show,
  setShow,
  selectedItem,
  handleClick,
  modalLoading,
}) => {
  const [name, setName] = useState(selectedItem?.name || "");
  const [discount, setDiscount] = useState(selectedItem?.percentage);

  const handleSubmit = () => {
    let params = {
      ...(selectedItem && { brandId: selectedItem?._id }),
      name,
    };
    for (const key in params) {
      if (!params[key]) {
        return RenderToast({
          type: "error",
          message: `${camelCaseToLower(key)} is required`,
        });
      }
    }
    params = {
      ...params,
      percentage: Number(discount),
    };
    handleClick(params);
  };

  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        header={selectedItem ? "Update Brand" : "Add Brand"}
        width="550px"
      >
        <div className={classes.mainWrapper}>
          <Input
            label="Brand Name"
            value={name}
            setter={setName}
            placeholder="Enter Brand Name"
          />
          <Input
            label="Discount (%)"
            value={discount}
            setter={(e) => {
              if (e && Number(e) > 100) {
                return RenderToast({
                  type: "error",
                  message: "Discount cannot be greater than 100",
                });
              }
              setDiscount(e);
            }}
            regexType="point"
            placeholder="Enter Discount (%)"
          />
        </div>
        <div className={classes.buttonsContainer}>
          <Button
            label="Cancel"
            onClick={() => setShow(false)}
            disabled={modalLoading}
          />
          <Button
            label={modalLoading ? "Saving..." : "Save"}
            onClick={handleSubmit}
            disabled={modalLoading}
            variant="secondary"
          />
        </div>
      </ModalSkeleton>
    </>
  );
};

export default AddEditBrandModal;
